// ==========================
// src/theme.js
// ==========================
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#ffcd02ff' },
    // primary: { main: '#d4af37' },
    
    secondary: { main: '#111111' },
    background: { default: '#ffffff' }
  },
  typography: {
    fontFamily: ['"DM Sans"', 'Inter', 'system-ui', 'Arial', 'sans-serif'].join(','),
    h2: { fontWeight: 800 },
    h4: { fontWeight: 700 },
    body1: { lineHeight: 1.7 }
  },
  shape: { borderRadius: 14 }
});

export default theme;